import React from 'react'
import { func, string, number } from 'prop-types'
import { css } from '@emotion/react'
import Stars from 'react-stars'

import theme from '../../theme'

const ratingWrapperCss = (size) => css`
  display: flex;
  align-items: center;
  position: relative;
  height: ${size}px;
  width: calc(5 * ${size}px + 40px);
`

const starsWrapperCss = css`
  position: absolute;
`

const starsCss = (size) => ({ fontFamily }) => css`
  display: flex;
  align-items: center;
  width: min-content;

  > span {
    padding: 0 5px;
    line-height: ${size + 4}px;
    font-family: ${fontFamily};
    font-weight: bold;

    &:first-of-type {
      padding-left: 0;
    }
  }
`

const VotingStars = ({ size = 28, className, rate, setRate }) => (
  <div className={className} css={ratingWrapperCss(size)}>
    <div css={starsWrapperCss}>
      <Stars
        css={starsCss(size)}
        color1={theme.colors.gray100}
        edit={false}
        size={size}
        half={false}
        char="☆"
      />
    </div>

    <div css={starsWrapperCss}>
      <Stars
        css={starsCss(size)}
        edit
        value={rate}
        color1="transparent"
        onChange={setRate}
        size={size}
        half={false}
      />
    </div>
  </div>
)

VotingStars.propTypes = {
  size: number,
  rate: number,
  setRate: func,
  className: string,
}

export default VotingStars
